<!--
* @Name：采购订单审批基本页面
* @Author: 刘玉
* @Date: 2021-12-09 10:39:49
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-09 10:39:49
-->
<template>
  <div>
    <hi-cell title="申请单号：" :value="modifyData.applyCode"></hi-cell>
    <hi-cell title="订单单号：" :value="modifyData.poNo"></hi-cell>
    <hi-cell title="公司：" :value="modifyData.corpFullName"></hi-cell>
    <hi-cell title="变更申请人：" :value="modifyData.crtUserName"></hi-cell>
    <hi-cell title="变更申请时间：" :value="modifyData.crtTime"></hi-cell>
    <hi-cell title="供应商：" :value="modifyData.suppName"></hi-cell>
    <hi-cell title="变更原因：" :value="modifyData.errorMsg"></hi-cell>
    <div class="order-card">
      <van-row class="order-title">订单抬头变更信息</van-row>
      <el-table :data="enquiryInfoTop" border fit>
        <el-table-column width="90" align="center" label="单据字段">
          <template slot-scope="{ row }">
            <span>{{ row.name }}</span>
          </template>
        </el-table-column>
        <!-- 修改信息 -->
        <el-table-column v-for="item in allListTop" :key="item.name" :label="item.name" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.field === 'purorgId' && item.purorgId">
              {{ item.purgrpId | dictFilter(purgrpOptions) }}
            </span>
            <span v-if="row.field === 'poTypeDict' && item.poTypeDict">
              {{ item.poTypeDict | dictFilter(poTypeOptions) }}
            </span>
            <span v-if="row.field === 'currencyDict' && item.currencyDict">
              {{ item.currencyDict | dictFilter(currencyDictOptions) }}
            </span>
            <span v-if="row.field === 'payCondDict' && item.payCondDict">
              {{ item.payCondDict | dictFilter(payTermOptions) }}
            </span>
            <span v-if="row.field === 'remark'">
              {{ item.remark }}
            </span>
            <span v-if="row.field === 'contactPerson'">
              {{ item.contactPerson }}
            </span>
            <span v-if="row.field === 'address'">
              {{ item.address }}
            </span>
            <span v-if="row.field === 'contactWay'">
              {{ item.contactWay }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="order-card" v-for="item in list" :key="item.rowNo">
      <van-row class="order-title">订单明细变更信息</van-row>
      <van-row class="order-detail">
        <span>订单行号：</span>
        <span>{{ item.rowNo }}</span>
      </van-row>
      <van-row class="order-detail">
        <span>物料编码：</span>
        <span>{{ item.matnr }}</span>
      </van-row>
      <van-row class="order-detail">
        <span>物料描述：</span>
        <span>{{ item.maktx }}</span>
      </van-row>
      <el-table :data="item.list" border fit style="margin-top: 10px">
        <el-table-column min-width="80" align="center" label="单据字段">
          <template slot-scope="{ row }">
            <span>{{ row.enquiryInfo['rowNo_' + row.rowNo].name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="index in 2"
          :key="index"
          :label="index === 1 ? '修改后' : '修改前'"
          align="center"
          min-min-width="150"
        >
          <template slot-scope="{ row }">
            <span v-if="row.enquiryInfo['rowNo_' + row.rowNo].field === 'deliveryDate'">
              {{ allList['rowNo_' + row.rowNo][index - 1].deliveryDate }}
            </span>
            <span v-if="row.enquiryInfo['rowNo_' + row.rowNo].field === 'purchaseQty'">
              {{ allList['rowNo_' + row.rowNo][index - 1].purchaseQty }}
            </span>
            <span v-if="row.enquiryInfo['rowNo_' + row.rowNo].field === 'price'">
              {{ allList['rowNo_' + row.rowNo][index - 1].price }}
            </span>
            <span v-if="row.enquiryInfo['rowNo_' + row.rowNo].field === 'itemAmount'">
              {{ allList['rowNo_' + row.rowNo][index - 1].itemAmount }}
            </span>
            <span v-if="row.enquiryInfo['rowNo_' + row.rowNo].field === 'isTax'">
              {{ allList['rowNo_' + row.rowNo][index - 1].isTax | dictFilter(yesNoOptions) }}
            </span>
            <span v-if="row.enquiryInfo['rowNo_' + row.rowNo].field === 'priceSourceDict'">
              {{ allList['rowNo_' + row.rowNo][index - 1].priceSourceDict | dictFilter(priceSourceOptions) }}
            </span>
            <span v-if="row.enquiryInfo['rowNo_' + row.rowNo].field === 'taxRate'">
              {{ allList['rowNo_' + row.rowNo][index - 1].taxRate }}
            </span>
            <span v-if="row.enquiryInfo['rowNo_' + row.rowNo].field === 'isPresent'">
              {{ allList['rowNo_' + row.rowNo][index - 1].isPresent | dictFilter(yesNoOptions) }}
            </span>
            <span v-if="row.enquiryInfo['rowNo_' + row.rowNo].field === 'exchangeRateTypeDict'">
              {{ allList['rowNo_' + row.rowNo][index - 1].exchangeRateTypeDict | dictFilter(exchangeRateTypeOptions) }}
            </span>
            <span v-if="row.enquiryInfo['rowNo_' + row.rowNo].field === 'serviceRate'">
              {{ allList['rowNo_' + row.rowNo][index - 1].serviceRate }}
            </span>
            <span v-if="row.enquiryInfo['rowNo_' + row.rowNo].field === 'remark'">
              {{ allList['rowNo_' + row.rowNo][index - 1].remark }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'
import {
  selectModifyData,
  selectModifyDetail,
  selectOriginModifyData,
  selectOriginModifyDetail,
  page as getPurgrpList
} from '@/api/purchaseOrderModify'
export default {
  name: 'ModifyInfo',
  data() {
    return {
      modifyData: {},
      originModifyData: {},
      modifyDetail: {},
      originModifyDetails: {},
      // poCreateHeadId: this.$store.getters.businessKey,
      poCreateHeadId: this.$route.query.businessKey,
      allListTop: [],
      enquiryInfoTop: [],
      enquiryTop: [
        { name: '采购组', field: 'purgrpId' },
        { name: '订单类型', field: 'poTypeDict' },
        { name: '币种', field: 'currencyDict' },
        { name: '付款条件', field: 'payCondDict' },
        { name: '订单摘要', field: 'remark' },
        { name: '收货人', field: 'contactPerson' },
        { name: '收货地址', field: 'address' },
        { name: '联系方式', field: 'contactWay' }
      ],
      purgrpOptions: [],
      list: [],
      allList: [],
      enquiryInfo: [],
      enquiry: [
        { name: '到货时间', field: 'deliveryDate' },
        { name: '采购数量', field: 'purchaseQty' },
        { name: '价格', field: 'price' },
        { name: '行金额', field: 'itemAmount' },
        { name: '是否含税', field: 'isTax' },
        { name: '价格来源', field: 'priceSourceDict' },
        { name: '税率', field: 'taxRate' },
        { name: '是否赠品', field: 'isPresent' },
        { name: '汇率类别', field: 'exchangeRateTypeDict' },
        { name: '服务费率', field: 'serviceRate' },
        { name: '备注', field: 'remark' }
      ],
      modifyItemList: {}
    }
  },
  computed: {
    poTypeOptions() {
      return this.$store.getters.dicts.po_type
    },
    currencyDictOptions() {
      return this.$store.getters.dicts.currency_dict
    },
    payTermOptions() {
      return this.$store.getters.dicts.pay_term
    },
    yesNoOptions() {
      return this.$store.getters.dicts.yes_no
    },
    priceSourceOptions() {
      return this.$store.getters.dicts.price_source
    },
    exchangeRateTypeOptions() {
      return this.$store.getters.dicts.exchange_rate_type
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    async initData() {
      const response = await getPurgrpList({ page: 1, limit: 1000 })
      this.purgrpOptions = response.data.rows.map(item => {
        const el = {
          value: item.purgrpId,
          labelDefault: item.purgrpLeaderName
        }
        return el
      })
      const modifyDataResp = await selectModifyData(this.poCreateHeadId)
      this.modifyData = modifyDataResp.data
      this.modifyData.name = '修改前'
      this.allListTop.push(this.modifyData)
      const originModifyDataResp = await selectOriginModifyData(this.poCreateHeadId)
      this.originModifyData = originModifyDataResp.data
      this.originModifyData.name = '修改后'
      this.allListTop.push(this.originModifyData)
      this.allListTop.forEach((e, index) => {
        if (index === 0) {
          Object.keys(e).forEach(key => {
            const value = e[key]
            if (this.allListTop[1][key] !== value) {
              const data = this.enquiryTop.find(item => item.field === key)
              if (data) {
                this.enquiryInfoTop.push(data)
              }
            }
          })
        }
      })

      const modifyDetailResp = await selectModifyDetail(this.poCreateHeadId)
      this.modifyDetail = modifyDetailResp.data

      this.modifyDetail.forEach(e => {
        if (this.modifyItemList['rowNo_' + e.rowNo]) {
          this.modifyItemList['rowNo_' + e.rowNo].push(e)
        } else {
          this.modifyItemList['rowNo_' + e.rowNo] = []
          this.modifyItemList['rowNo_' + e.rowNo].push(e)
        }
      })

      const originModifyDetailsResp = await selectOriginModifyDetail(this.poCreateHeadId)
      this.originModifyDetails = originModifyDetailsResp.data
      this.originModifyDetails.forEach(e => {
        if (this.modifyItemList['rowNo_' + e.rowNo]) {
          this.modifyItemList['rowNo_' + e.rowNo].push(e)
        } else {
          this.modifyItemList['rowNo_' + e.rowNo] = []
          this.modifyItemList['rowNo_' + e.rowNo].push(e)
        }
      })
      // modifyItemList -> rowNo-> 0, 1
      Object.keys(this.modifyItemList).forEach(key => {
        const e = this.modifyItemList[key]
        // rowNo -> 0,1
        e.forEach((el, index) => {
          if (!this.allList[key]) {
            this.allList[key] = []
            this.allList[key][0] = []
            this.allList[key][1] = []
            this.allList[key][0].name = '修改前'
            this.allList[key][1].name = '修改后'
          }

          if (index === 0) {
            Object.keys(el).forEach(key1 => {
              const value = el[key1]
              if (this.modifyItemList[key][1][key1] !== value) {
                // 变更的数值
                this.allList[key][0][key1] = value
                this.allList[key][1][key1] = this.modifyItemList[key][1][key1]
                // 获取字段名
                const data = this.enquiry.find(item => item.field === key1)
                if (data) {
                  if (this.enquiryInfo[key]) {
                    this.enquiryInfo[key].push(data)
                  } else {
                    this.enquiryInfo[key] = []
                    this.enquiryInfo[key].push(data)
                  }
                }
              }
            })
          }
        })
      })

      // 循环新增行
      let modifyDetailList = []
      Object.keys(this.modifyItemList).forEach(key => {
        const e = this.modifyItemList[key]
        e.forEach(el => {
          const index = modifyDetailList.findIndex(item => item.rowNo === el.rowNo)
          if (index === -1) {
            const newList = this.enquiryInfo[key].map(element => {
              const newObj = cloneDeep(el)
              newObj.enquiryInfo = {}
              newObj.enquiryInfo[key] = element
              return newObj
            })
            modifyDetailList = [...modifyDetailList, ...newList]
          }
        })
      })
      this.list = this.splitList(modifyDetailList)
    },

    splitList(list) {
      if (list < 1) return list
      const fistRow = {
        rowNo: list[0].rowNo,
        matnr: list[0].matnr,
        maktx: list[0].maktx,
        list: [list[0]]
      }

      const splitList = [fistRow]
      if (list.length === 1) return [fistRow]
      for (let i = 1; i < list.length; i++) {
        const index = splitList.findIndex(item => item.rowNo === list[i].rowNo)
        if (index !== -1) {
          splitList[index].list.push(list[i])
        } else {
          splitList.push({
            rowNo: list[i].rowNo,
            matnr: list[i].matnr,
            maktx: list[i].maktx,
            list: [list[i]]
          })
        }
      }

      return splitList
    }
  }
}
</script>
<style lang="css" scoped>
.order-card {
  border: 1px solid #969799;
  border-radius: 10px;
  padding: 0 10px 10px 10px;
  margin-bottom: 10px;
}
.order-title {
  color: #000;
  font-weight: bold;
  margin: 10px 0;
  font-size: 16px;
}
.order-detail {
  color: #323233;
  line-height: 28px;
  font-size: 16px;
}
</style>
